// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1Zul_","Input":"Auth_Input__2LQ-q"};